import { useCartItemsQuery } from '@/queries/useCartItemsQuery';
import { TieredDiscountProgress } from './TieredDiscountProgress';
import { useTieredDiscount } from '@features/pdp/hooks/useTieredDiscount';
import { ComponentProps } from 'react';

type Props = {
  variant?: ComponentProps<typeof TieredDiscountProgress>['variant'];
  maxVisibleTiers?: number;
  className?: string;
  enabled?: boolean;
};

const TieredDiscount = ({
  variant = 'default',
  maxVisibleTiers = 3,
  className = '',
  enabled = true,
}: Props) => {
  const { data, isLoading: isInitialLoading } = useCartItemsQuery({ enabled });
  const { isVisible, currentProgress, nextTierInfo, tiers, currentSubtotal } = useTieredDiscount(data, {
    maxVisibleTiers,
  });

  if (!isVisible || isInitialLoading || !enabled) return null;

  return (
    <TieredDiscountProgress
      currentProgress={currentProgress}
      tiers={tiers}
      nextTierInfo={nextTierInfo}
      currentSubtotal={currentSubtotal}
      variant={variant}
      className={className}
    />
  );
};

export default TieredDiscount;
